import { useCurrentUser } from '@qualio/ui-components';
import { useQuery } from 'react-query';
import { Tag } from '../api/model/tag';
import { TagApi } from '../api/tag';

export const useTags = () => {
  const currentUser = useCurrentUser();

  const loadTags = async (): Promise<Tag[]> => TagApi.fetchTags(currentUser);

  return useQuery({
    queryFn: loadTags,
    queryKey: ['tags', currentUser.companyId],
    refetchOnWindowFocus: false,
  });
};
